import React, { Fragment } from 'react';
//import _ from "lodash";
import { withStyles } from '@material-ui/core';
import { getGlobalClasses } from '../../themes';
import Grid from '@material-ui/core/Grid';

import blueSemiTruckSvg from '../../images/calendar/blueSemiTruck.svg';
import usersSvg from '../../images/calendar/users.svg';
import TerminalCharts from '../../components/assignments/TerminalCharts';
import _ from 'lodash';
import AuthUserContainer from '../../containers/AuthUser';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		card: {
			height: 80,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			padding: `15px 20px`,
			'&:hover': {
				border: '1px solid rgba(32,150,243,.8)',
				backgroundColor: `rgba(32,150,243,.2)`,
			},
		},
		blueSemiTruckIcon: {
			display: 'inline-block',
			width: 45,
			height: 48,
			backgroundImage: `url('${blueSemiTruckSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		driversIcon: {
			display: 'inline-block',
			width: 48,
			height: 48,
			backgroundImage: `url('${usersSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
		pickCardTitleContainer: {
			display: 'flex',
			alignContent: 'center',
			alignItems: 'center',
		},
		pickerCardTitle: {
			paddingLeft: 10,
			fontSize: 28,
			color: '#333',
			textDecoration: 'none',
			fontWeight: 200,
		},
	};
};

function SchedulingDashboard({ permissions, classes }) {
	if (!permissions || !_.includes(permissions, 'canUpdateScheduling')) {
		return <div>You do not have valid permissions to view this page.</div>;
	}

	return (
		<Fragment>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<div className={classes.globalMainHeadline}>Terminal Schedule Usage</div>
				</Grid>
				<TerminalCharts showShifts={false} />
			</Grid>
		</Fragment>
	);
}

export default _.flow([withStyles(styles, { withTheme: true }), AuthUserContainer])(
	SchedulingDashboard
);
